module.exports = __webpack_public_path__ + "static/media/urbangoo08.df75169e.webp";